'use client';

import Banner from 'src/components/main/Banner/Banner';
import DailyAttendanceSnackbar from 'src/components/main/DailyAttendance/Snackbar';
import GuidesSection from 'src/components/main/Section/GuidesSection/GuidesSection';
import MyPickSection from 'src/components/main/Section/MyPickSection/MyPickSection';
import OriginalsSection from 'src/components/main/Section/OriginalsSection/OriginalsSection';
import type { NextPageWithLayout } from 'src/types/common.types';

import DefaultLayout from '@/layout/PageLayout/DefaultLayout/DefaultLayout';

const NewMainPage: NextPageWithLayout = () => {
  return (
    <>
      <Banner />
      <DailyAttendanceSnackbar />
      <MyPickSection />
      <OriginalsSection />
      <GuidesSection />
    </>
  );
};

NewMainPage.getLayout = (page) => {
  return (
    <DefaultLayout backgroundColor="#0D0A17" layoutBackgroundColor="#fff">
      {page}
    </DefaultLayout>
  );
};

export default NewMainPage;
